import script from "./HeroSectionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroSectionComponent.vue?vue&type=script&setup=true&lang=js"

import "./HeroSectionComponent.vue?vue&type=style&index=0&id=d66a9ca4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d66a9ca4"]])

export default __exports__